class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '95ade4bf';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1185.0.8';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Tue, 14 Jul 2026 16:01:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-07-14 12:01:09 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-07-14 12:01:09 Boston - 95ade4bf - 1185.0.8';
export default BuildTags;
